





























































//@ts-ignore
import store from "../store";
import {Component, Vue} from 'vue-property-decorator';
import {CurrentGame, GameSettings} from "../../types";
import EventApi from "../api/EventsApi";

const TASK_STATE_TYPE_CUSTOM = 2;

@Component({
    props: {
        taskVisibility: {
            required: true,
            type: Object
        },
        players: {
            required: true,
            type: Array
        },
        playerId: {
            required: true,
            type: String
        },
        taskSettings: {
            required: true,
            type: Object
        },
        tableModeOn: {
            required: true,
            type: Boolean
        }
    },
})

export default class GameTaskSetup extends Vue {
    private taskAddMenuVisible: boolean = false;
    private tableModeOn!: boolean;
    private TASK_STATE_TYPE_CUSTOM: number = TASK_STATE_TYPE_CUSTOM;
    private taskSettings!: any;
    private taskVisibility!: any;

    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    private get gameField(): any
    {
        return store.getters.getGameField;
    }

    /**
     * Текущая игра
     */
    private get currentActivity(): CurrentGame|null
    {
        return store.getters.getCurrentActivity;
    }

    /**
     * Настройки текущей игры
     */
    private get currentActivitySettings(): GameSettings|null
    {
        if (!this.currentActivity) {
            return null;
        }
        return this.currentActivity.settings;
    }

    /**
     * Видны ли иконки игроков
     */
    private get taskIsManageable(): boolean
    {
        if (!this.currentActivitySettings) {
            return true;
        }
        return this.currentActivitySettings.canManageTasks;
    }

    /**
     * Видны ли иконки игроков
     */
    private get tableIsManageable(): boolean
    {
        if (!this.currentActivitySettings) {
            return true;
        }
        return this.currentActivitySettings.canManageHandtable;
    }

    /**
     * Изменить общую видимость
     */
    private changeOverallTaskVisibility(): void
    {
        this.$emit('changeVisibility', 'main');
        this.$emit('changeVisibility', 'additional');
    }

    /**
     * Изменить видимость для игрока
     * @param playerId
     */
    private changePlayerTaskVisibility(playerId: any): void
    {
        this.$emit('changePlayerVisibility', playerId, 'main');
        this.$emit('changePlayerVisibility', playerId, 'additional')
    }

    /**
     * Переключить видимость меню добавления задания
     */
    private toggleTaskAddMenu(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.taskAddMenuVisible = !this.taskAddMenuVisible;
    }

    private closeTaskAddMenu() : void
    {
        this.taskAddMenuVisible = false;
    }

    /**
     * Открыть форму добавления задания определенного типа
     * @param taskType
     */
    private showTaskForm(taskType: any): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('showTaskForm', taskType);
        this.closeTaskAddMenu();
    }

    /**
     * Показать кнопку добавления задания
     * @return {boolean}
     */
    private showAddTaskButton(): any
    {
        if (!store.getters.getGameState.tasks) {
            return true;
        }
        return !(store.getters.getGameState.tasks.main.is_filled && store.getters.getGameState.tasks.additional.is_filled);
    }

    public isTaskVisibleForAll(): any
    {
        return this.taskSettings.visibility === this.taskVisibility.VISIBLE;
    }

    /**
     * Проверить видимость задачи для конкретного игрока
     * @param playerId
     * @returns {boolean}
     */
    private isTaskVisibleForPlayer(playerId: any): any
    {
        return this.isTaskVisibleForAll() || this.taskSettings.visibleFor.indexOf(playerId) !== -1;
    }

    /**
     * Добавить карту на стол
     * @private
     */
    private addCards(): void
    {
        this.$emit('addCards');
    }
}
